import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { Model } from "appworks/model/model";
import { Services } from "appworks/services/services";
import { State } from "appworks/state-machine/states/state";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { Parallel } from "appworks/utils/contracts/parallel";
import { LoadFreespinCommand } from "slotworks/commands/comms/load-freespin-command";
import { StartSpinCommand } from "slotworks/commands/comms/start-spin-command";
import { FooterComponent } from "slotworks/components/footer/footer-component";
import { AbstractMatrixComponent } from "slotworks/components/matrix/abstract-matrix-component";
import { ReelSpinner } from "slotworks/components/matrix/reel/transition-behaviours/spin/reel-spinner";

export class RequestFreespin extends State {
    protected skipping: boolean;

    public onEnter(cascadeSkip?: boolean) {
        this.skipping = cascadeSkip;

        if (this.skipping || !Services.jurisdiction.getSpinSkippingEnabled()) {
            uiFlags.set(UIFlag.NO_SKIP, true);
        }

        uiFlags.set(UIFlag.IDLE, false);
        uiFlags.set(UIFlag.GAME_IN_PROGRESS, true);
        uiFlags.set(UIFlag.AWAITING_RESPONSE, true);

        Components.get(FooterComponent)?.showFreespinStart();

        ReelSpinner.disableMinSpinTime = true;

        new Parallel([
            () => StartSpinCommand(),
            () => LoadFreespinCommand()
        ]).then(() => this.resolveEnter());
    }

    public onExit() {
        uiFlags.set(UIFlag.AWAITING_RESPONSE, false);
    }

    public error() {
        Components.get(AbstractMatrixComponent).reset();
        Services.autoplay.stop();
        Model.write({ settings: { turboSpin: false } });

        super.error();
    }

    public onSkip() {
        this.skipping = true;
    }

    protected resolveEnter(): void {
        if (!gameState.getCurrentGame().getCurrentRecord()) {
            this.error();
        } else {
            gameState.getCurrentGame().nextRecord();

            if (this.skipping) {
                this.skip();
            } else {
                this.complete();
            }
        }
    }
}
